import {
    PROFILE_USER_REQUEST,
    PROFILE_USER_RECEIVE,
    PROFILE_USER_CHANGE_VALUE,
    PROFILE_USER_SEND_SAVE,
    PROFILE_USER_RECEIVE_SAVE,
    PROFILE_USER_RECEIVE_SAVE_ERROR,
    PROFILE_USER_EDIT
} from "../config/actions";

let defaultState = {
    username: '',
    changePassword: false,
    oldPassword: '',
    newPassword1: '',
    newPassword2: '',
    edit: false,
    loading: false,
    errors: false
};

const userReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(PROFILE_USER_REQUEST):
            return Object.assign({}, state, defaultState);
        case(PROFILE_USER_RECEIVE):
            return Object.assign({}, state, {
                username: action.data.username
            });
        case(PROFILE_USER_CHANGE_VALUE):
            return Object.assign({}, state, {
                [action.name]: action.value
            });
        case(PROFILE_USER_EDIT):
            return Object.assign({}, state, {
                edit: true
            });
        case(PROFILE_USER_SEND_SAVE):
            return Object.assign({}, state, {
                errors: false,
                loading: true
            });
        case(PROFILE_USER_RECEIVE_SAVE):
            return Object.assign({}, state, {
                changePassword: false,
                edit: false,
                loading: false
            });
        case(PROFILE_USER_RECEIVE_SAVE_ERROR):
            return Object.assign({}, state, {
                edit: true,
                loading: false,
                errors: action.data.errors
            });
        default:
            return state;
    }
};

export default userReducer;